import { createSlice } from '@reduxjs/toolkit';
import { fetchAppPublisherInfo } from './appThunk';
import { IDeveloperResponse } from '@models/scraperModel/developerModel';
import { COLLECTION, CATEGORY } from '@models/app/featuredModel';

type featuredAppDataListPayload = {
  payload: { provider_type: string; tab_type: string; dataObj: dataObjType };
};

type dataObjType = {
  category: string;
  collection: string;
  data: any; //TODO: 추후 list 모델 적용시키기.
};

const appSlice = createSlice({
  name: 'app',
  initialState: {
    publisherInfo: null as IDeveloperResponse[],
    // featuredAppsDataList 데이터 (여러번 요청을 막기 위한 redux 관리)
    featuredAppsDataList: {
      google: {
        game: [] as dataObjType[],
        app: [] as dataObjType[],
      },
      apple: {
        game: [] as dataObjType[],
        app: [] as dataObjType[],
      },
    },
  },
  reducers: {
    setFeaturedAppDataList: (state, { payload }: featuredAppDataListPayload) => {
      const { provider_type, tab_type, dataObj } = payload;
      // 기존의 category, collection 이 있다면 그곳의 데이터를 변경처리
      const findObjIndex = state.featuredAppsDataList[provider_type][tab_type].findIndex(
        (item) => item.collection === dataObj.collection && item.category === dataObj.category
      );
      if (findObjIndex >= 0) {
        state.featuredAppsDataList[provider_type][tab_type][findObjIndex] = dataObj;
      } else {
        // 없다면 concat 으로 추가 처리
        state.featuredAppsDataList[provider_type][tab_type] =
          state.featuredAppsDataList[provider_type][tab_type].concat(dataObj);
      }
    },
  },
  extraReducers: {
    [fetchAppPublisherInfo.fulfilled.type]: (state, { payload }) => {
      state.publisherInfo = payload;
    },
  },
});

export const { setFeaturedAppDataList } = appSlice.actions;
export const appSliceName = appSlice.name;
export default appSlice.reducer;
